import { useAppSelector } from "../app/hooks";
import { User } from "../features/user/user";

interface CurrentUser {
  user: User | null;
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
}

export const useCurrentUser = (): CurrentUser => {
  const user = useAppSelector((state) => state.user.user);

  const fullName =
    user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : "";

  return {
    user,
    id: user?.id || "",
    username: user?.username || "",
    email: user?.email || "",
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    fullName,
  };
};

export default useCurrentUser;
